export default "__VITE_ASSET__6lUmWWNJ__"